module.exports = __webpack_public_path__ + "img/1m3.11cf82eb.jpg";